import React from "react";
import Link from "next/link";
import dynamic from "next/dynamic";

import ViewJobs from "./ViewJobs.pc";
import styles from "./Company.pc.module.scss";
const BrandSwiper = dynamic(() => import("../CompanyBrand/brandSwiper.pc"), { ssr: true });

export default function Company({ data, lang, isMobile, isRemote, jobId }) {
  return (
    <div className={styles.company}>
      <Link href={data.company_url}>
        <div className={styles.logoBg}>
          <span className={styles.logo}>
            <img src={data.logo} alt='' />
          </span>
          <p className={styles.companyName}>{data.name}</p>
        </div>
        <div className={styles.companyInfo}>
          {data.financing_stage ? (
            <p className={styles.infoPara}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
              >
                <path
                  d='M13.1889 6.49968C13.2807 6.81806 13.6133 7.00168 13.9317 6.90981C14.2501 6.81794 14.4337 6.48536 14.3418 6.16698L13.1889 6.49968ZM2.23438 6.33333L1.6579 6.16698C1.60562 6.34814 1.64154 6.54334 1.75489 6.69402C1.86824 6.8447 2.04582 6.93333 2.23438 6.93333V6.33333ZM8 6.33333L8.37482 5.86481C8.26843 5.7797 8.13624 5.73333 8 5.73333V6.33333ZM7.99986 2.6C10.4608 2.6 12.5388 4.24676 13.1889 6.49968L14.3418 6.16698C13.5475 3.4142 11.0097 1.4 7.99986 1.4V2.6ZM2.81085 6.49968C3.46096 4.24676 5.53888 2.6 7.99986 2.6V1.4C4.99005 1.4 2.45225 3.4142 1.6579 6.16698L2.81085 6.49968ZM2.23438 6.93333H8V5.73333H2.23438V6.93333ZM7.62518 6.80185L9.29185 8.13519L10.0415 7.19814L8.37482 5.86481L7.62518 6.80185Z'
                  fill='#7D7D7D'
                />
                <path
                  d='M2.81112 9.50032C2.71925 9.18194 2.38668 8.99832 2.0683 9.09019C1.74992 9.18206 1.56629 9.51464 1.65817 9.83302L2.81112 9.50032ZM13.7656 9.66667L14.3421 9.83302C14.3944 9.65186 14.3585 9.45666 14.2451 9.30598C14.1318 9.1553 13.9542 9.06667 13.7656 9.06667V9.66667ZM8 9.66667L7.62518 10.1352C7.73157 10.2203 7.86376 10.2667 8 10.2667V9.66667ZM8.00014 13.4C5.53915 13.4 3.46124 11.7532 2.81112 9.50032L1.65817 9.83302C2.45252 12.5858 4.99033 14.6 8.00014 14.6V13.4ZM13.1891 9.50032C12.539 11.7532 10.4611 13.4 8.00014 13.4V14.6C11.0099 14.6 13.5478 12.5858 14.3421 9.83302L13.1891 9.50032ZM13.7656 9.06667H8V10.2667H13.7656V9.06667ZM8.37482 9.19815L6.70815 7.86481L5.95852 8.80186L7.62518 10.1352L8.37482 9.19815Z'
                  fill='#7D7D7D'
                />
              </svg>
              <span>{data.financing_stage}</span>
            </p>
          ) : null}
          {data.company_size ? (
            <p className={styles.infoPara}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
              >
                <path
                  d='M10.6667 2.31184C11.6545 2.80274 12.3334 3.82209 12.3334 5C12.3334 6.17791 11.6545 7.19726 10.6667 7.68816M12 11.1776C13.0077 11.6336 13.9151 12.3767 14.6667 13.3333M1.33337 13.3333C2.63103 11.6817 4.39283 10.6667 6.33337 10.6667C8.27392 10.6667 10.0357 11.6817 11.3334 13.3333M9.33337 5C9.33337 6.65685 7.99023 8 6.33337 8C4.67652 8 3.33337 6.65685 3.33337 5C3.33337 3.34315 4.67652 2 6.33337 2C7.99023 2 9.33337 3.34315 9.33337 5Z'
                  stroke='#7D7D7D'
                  strokeWidth='1.2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
              <span>{data.company_size}</span>
            </p>
          ) : null}
          {data.industry ? (
            <p className={styles.infoPara}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
              >
                <path
                  d='M8.66671 7.33333H11.8667C12.6134 7.33333 12.9868 7.33333 13.272 7.47866C13.5229 7.60649 13.7269 7.81046 13.8547 8.06135C14 8.34656 14 8.71993 14 9.46667V14M8.66671 14V4.13333C8.66671 3.3866 8.66671 3.01323 8.52138 2.72801C8.39355 2.47713 8.18958 2.27316 7.93869 2.14532C7.65348 2 7.28011 2 6.53337 2H4.13337C3.38664 2 3.01327 2 2.72805 2.14532C2.47717 2.27316 2.2732 2.47713 2.14537 2.72801C2.00004 3.01323 2.00004 3.3866 2.00004 4.13333V14M14.6667 14H1.33337M4.33337 4.66667H6.33337M4.33337 7.33333H6.33337M4.33337 10H6.33337'
                  stroke='#7D7D7D'
                  strokeWidth='1.2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
              <span>{data.industry}</span>
            </p>
          ) : null}
        </div>
      </Link>
      <BrandSwiper
        data={{
          title: data.title,
          brand_and_product_info: data.brand_and_product_info
        }}
        jobId={jobId}
        isMobile={isMobile}
        pageType='job-detail'
      />
      <ViewJobs data={data} lang={lang} isMobile={isMobile} isRemote={isRemote} />
    </div>
  );
}
